import Isotope from "isotope-layout/js/isotope.js";
import imagesLoaded from "imagesloaded/imagesloaded.js";

const elem = document.querySelector(".filter-grid");
const iso = new Isotope(elem, {
  // options
  itemSelector: ".grid-item",
  layoutMode: "fitRows",
  stagger: 30,
});
imagesLoaded(elem, function() {
  iso.layout();
});

// filter items on button click
const controls = document.querySelectorAll(".filter-control");
const resetBtn = document.querySelector(".filter-reset");
let curBtn = document.querySelector(".selected");

const setSelected = (selected) => {
  if (curBtn) {
    curBtn.classList.remove("selected");
  }
  curBtn = selected;
  curBtn.classList.add("selected");
  resetBtn.disabled = resetBtn.classList.contains('selected');
};

for (const btn of controls) {
  const val = btn.dataset.filter;
  btn.addEventListener("click", () => {
    setSelected(btn);
    iso.arrange({
      filter: val,
    });
  });
}
